module.exports = __webpack_public_path__ + "static/media/WebsiteBlocker2.a557c77e.png";